// LUẬT THỨ TỰ của sơ đồ (04/10/2026) — tách khỏi so-do.ts để MÁY CHỦ (chuanHoaSoDo/kiemSoDo) và TRANG WEB (kéo-thả, menu ⋯, bảng thêm
// bước) dùng CHÍNH một hàm: trang kiểm trước khi gửi (khe vi phạm hiện màu cấm, không gửi), máy chủ vẫn kiểm lại như cũ. Chỉ các luật
// phụ thuộc THỨ TỰ thao tác (không phụ thuộc giá trị tham số): trùng bước, "cần danh sách ngay trước", tổ hợp như người (chỉ có nghỉ /
// nghỉ đứng cuối / xem sau khi đã tương tác), hai bước nghỉ liền nhau. Câu báo giữ nguyên chữ-từng-chữ như trước khi tách.
// (07/10/2026) DÙNG MỘT THAO TÁC NHIỀU LẦN: không còn luật "mỗi kịch bản chỉ dùng thao tác này MỘT lần" — lần dùng thứ n ≥ 2 tự mang hậu tố `_n` cho id bước + tên tham số kịch bản (lan-dung.ts,
// khoi-lan-n.ts), nên hai bước không bao giờ dùng chung một id thật (kể cả hai thao tác KHÁC nhau trùng một bước nội bộ). loiTrungBuoc chỉ còn là lưới an toàn.
// Chỉ import KIỂU → trang web Boss đóng gói được mà không kéo theo thư viện khối/YAML/zod.
import type { ThaoTac } from "./ban-do";
import { idLapLai, lanTheoIds } from "./lan-dung";

/** Cấu trúc khối của một thao tác: id các bước, danh sách tạo ra (extract into), danh sách cần dùng (for_each). */
export interface CauTrucKhoi { ids: string[]; taoDs: string[]; canDs: string[] }
/** Phần cấu trúc trang web cần để kiểm thứ tự (gửi kèm bản đồ công khai — không lộ yamlSteps/selector). */
export interface ThuTuThaoTac extends CauTrucKhoi { nghi: boolean }
/** Một bước của sơ đồ đang kiểm: mã + tên ngắn + cấu trúc. `dich` = địa chỉ MỘT bài/video người dùng đưa (bai_url / video_url đã cắt khoảng trắng; rỗng / không có = làm trên danh sách / tự tìm). */
export interface MucThuTu extends ThuTuThaoTac { ma: string; tenNgan: string; dich?: string }

type KhoiCanDoc = Pick<ThaoTac, "khoi">;
const cacKhuc = (yaml: string): string[] => yaml.split(/^(?=  - id:)/m).filter((c) => /^  - id:/.test(c));

export function cauTrucThaoTac(t: KhoiCanDoc): CauTrucKhoi {
  const ids: string[] = [], taoDs: string[] = [], canDs: string[] = [];
  for (const c of cacKhuc(t.khoi.yamlSteps)) {
    const id = /^  - id:\s*([A-Za-z0-9_]+)/.exec(c)![1]!;
    ids.push(id);
    const into = /^\s+into:\s*([A-Za-z_][A-Za-z0-9_]*)\s*$/m.exec(c)?.[1];
    // extract MỘT giá trị (mode single — vd chữ của bài đang mở để AI trích dẫn) không tạo DANH SÁCH: không được che danh sách của bước tìm phía trước.
    const motGiaTri = (t.khoi.learned?.[id] as { extract_spec?: { mode?: string } } | undefined)?.extract_spec?.mode === "single";
    if (into && /^\s+extract:/m.test(c) && !motGiaTri) taoDs.push(into);
    const fe = /^\s+for_each:\s*([A-Za-z_][A-Za-z0-9_]*)\s*$/m.exec(c)?.[1];
    if (fe && !taoDs.includes(fe) && !canDs.includes(fe)) canDs.push(fe);
  }
  return { ids, taoDs, canDs };
}

// Thao tác "nghỉ" = khối CHỈ gồm bước chờ (wait) — nhận theo cấu trúc, không theo tên, nên áp được cho nghỉ của mọi mạng.
export function laThaoTacNghi(t: KhoiCanDoc): boolean {
  const chunks = cacKhuc(t.khoi.yamlSteps);
  return chunks.length > 0 && chunks.every((c) => /^\s+wait:/m.test(c) && !/^\s+(?:on|do|extract|generate|classify|filter|for_each|steps):/m.test(c));
}

export function thuTuCua(t: KhoiCanDoc): ThuTuThaoTac {
  return { ...cauTrucThaoTac(t), nghi: laThaoTacNghi(t) };
}

// Bước của bundle mang id của khối; khối dùng lần thứ n ≥ 2 trong một kịch bản thì id thành <id>_2, <id>_3… (lan-dung.ts; khớp sinhKichBan của tu-dung.ts).
export { idLapLai };

/** Lần dùng của từng nút (số nhỏ nhất để mọi id bước thật duy nhất — lan-dung.ts lanTheoIds). */
export function lanTheoNut(ds: Pick<MucThuTu, "ids">[]): number[] {
  return lanTheoIds(ds.map((t) => t.ids));
}

/** Id bước THẬT của từng nút sau khi lắp: thao tác dùng lần thứ n ≥ 2 (kể cả hai thao tác khác nhau trùng một bước nội bộ) → "<id>_<n>"; lần 1 giữ nguyên. */
export function idsTheoNut(ds: Pick<MucThuTu, "ids">[]): string[][] {
  const lan = lanTheoNut(ds);
  return ds.map((t, j) => t.ids.map((id) => idLapLai(id, lan[j]!)));
}

/** LƯỚI AN TOÀN: hai bước dùng chung một id bước thật. Không xảy ra với thư viện khối hiện tại (idsTheoNut đã đổi id theo lần dùng) — chỉ để bắt khối lỗi thư viện (một khối tự lặp id). */
export function loiTrungBuoc(ds: MucThuTu[]): string[] {
  const loi: string[] = [];
  const idsThat = idsTheoNut(ds);
  const buocDau = new Map<string, number>();
  ds.forEach((_c, j) => {
    for (const sid of idsThat[j]!) {
      const k = buocDau.get(sid);
      if (k !== undefined && k !== j) {
        loi.push(`Bước ${j + 1} (${ds[j]!.tenNgan}) và bước ${k + 1} (${ds[k]!.tenNgan}) bị trùng một bước nội bộ — lỗi của thư viện thao tác, không phải của bạn; báo người quản trị`);
        break;
      }
      if (k === undefined) buocDau.set(sid, j);
    }
  });
  return loi;
}

// ---------------- PHÂN LOẠI VÀNG / ĐỎ (Giai đoạn 0, 07/10/2026 — "cảnh báo thay vì cấm cứng khi soạn sơ đồ") ----------------
// Các luật THỨ TỰ dưới đây trước đây đều là lỗi CỨNG (không lưu được). Nay trang bấm tay xếp chúng thành hai mức (phanLoaiThuTu, cuối tệp):
//   VÀNG = cảnh báo, sơ đồ vẫn dịch + chạy được (nghỉ cuối / chỉ có nghỉ / xem sau thích / hai nghỉ liền / danh sách tạo ở XA hơn bước gần nhất);
//   ĐỎ   = không chạy được tới khi sửa (bước cần danh sách mà phía trước KHÔNG bước nào tạo danh sách đó).
// AI viết/sửa sơ đồ + gói seeding + mẫu Super vẫn dùng loiThuTu / loiToHop / loiNghiLien / loiCanDanhSach (CỨNG, không đổi một chữ).
export type MucCanhBao = "vang" | "do";
/** Một mục phân loại: `buoc` = số thứ tự bước (1-based) trên màn hình; `ma` = mã ổn định; `loi` = câu tiếng Việt GIỐNG HỆT câu của hàm cũ. */
export interface PhanLoaiBuoc { buoc: number; muc: MucCanhBao; ma: string; loi: string }
interface MucThuTuChiTiet { buoc: number; ma: string; loi: string }

/** Bước dùng danh sách (for_each) phải có bước tạo đúng danh sách đó NGAY trước (bỏ qua các bước không tạo danh sách). `tatCa` = mọi thao
 *  tác của mạng (để nêu tên bước nguồn). */
export function loiCanDanhSach(ds: MucThuTu[], tatCa: Pick<MucThuTu, "tenNgan" | "taoDs">[]): string[] {
  const loi: string[] = [];
  ds.forEach((c, j) => {
    for (const d of c.canDs) {
      let k = j - 1;
      while (k >= 0 && !ds[k]!.taoDs.length) k--;
      if (k < 0 || !ds[k]!.taoDs.includes(d)) {
        const nguon = tatCa.find((t) => t.taoDs.includes(d));
        loi.push(`Bước ${j + 1} (${c.tenNgan}) cần danh sách từ bước “${nguon?.tenNgan ?? d}” đặt ngay trước nó`);
      }
    }
  });
  return loi;
}
/** Như loiCanDanhSach nhưng có mức: bước tạo danh sách đó nằm ở XA hơn (có bước khác tạo danh sách khác chen giữa) → VÀNG "can_ds_xa" — runtime lưu danh sách theo
 *  tên biến toàn cục của lần chạy nên bước vẫn tìm thấy danh sách; KHÔNG bước nào phía trước tạo danh sách đó → ĐỎ "can_ds_thieu". */
function canDanhSachChiTiet(ds: MucThuTu[], tatCa: Pick<MucThuTu, "tenNgan" | "taoDs">[]): (MucThuTuChiTiet & { muc: MucCanhBao })[] {
  const out: (MucThuTuChiTiet & { muc: MucCanhBao })[] = [];
  ds.forEach((c, j) => {
    for (const d of c.canDs) {
      let k = j - 1;
      while (k >= 0 && !ds[k]!.taoDs.length) k--;
      if (k >= 0 && ds[k]!.taoDs.includes(d)) continue;
      const nguon = tatCa.find((t) => t.taoDs.includes(d));
      const xa = ds.slice(0, j).some((x) => x.taoDs.includes(d));
      out.push({ buoc: j + 1, muc: xa ? "vang" : "do", ma: xa ? "can_ds_xa" : "can_ds_thieu", loi: `Bước ${j + 1} (${c.tenNgan}) cần danh sách từ bước “${nguon?.tenNgan ?? d}” đặt ngay trước nó` });
    }
  });
  return out;
}

// Người thật XEM/ĐỌC trước rồi mới thích/bình luận. Cặp vô lý (xem đặt SAU việc tương tác trên cùng đích): xem MỘT video sau khi đã thích/bình luận/
// trả lời chính video đó (cùng tham số bai_url của kịch bản), hoặc lướt xem các video tìm được sau khi đã bình luận chính danh sách đó.
const XEM_SAU: Record<string, string[]> = {
  xem_video: ["thich_video", "binh_luan_mot_bai", "tra_loi_mot_binh_luan", "thich_binh_luan"],
  luot_video: ["binh_luan"],
};
/** Tổ hợp vô lý theo thứ tự (TỔ HỢP NHƯ NGƯỜI, 2026-10-01): chỉ có nghỉ, nghỉ đứng cuối, xem đặt sau khi đã tương tác. */
type MucToHop = Pick<MucThuTu, "ma" | "tenNgan" | "nghi"> & Partial<Pick<MucThuTu, "taoDs" | "dich">>;
function toHopChiTiet(ds: MucToHop[]): MucThuTuChiTiet[] {
  const out: MucThuTuChiTiet[] = [];
  const n = ds.length;
  if (n && ds.every((t) => t.nghi)) out.push({ buoc: 1, ma: "chi_nghi", loi: "Kịch bản chỉ có bước nghỉ — cần ít nhất một việc thật (tìm, xem, lướt, bình luận…)" });
  else if (n > 1 && ds[n - 1]!.nghi) out.push({ buoc: n, ma: "nghi_cuoi", loi: `Bước ${n} (${ds[n - 1]!.tenNgan}) đứng cuối không có tác dụng — nghỉ phải nằm GIỮA hai việc; bỏ bước này hoặc chuyển lên trước một việc` });
  ds.forEach((m, j) => {
    for (let k = 0; k < j; k++) {
      if (XEM_SAU[m.ma]?.includes(ds[k]!.ma) && cungDoiTuong(ds, k, j)) out.push({ buoc: j + 1, ma: "xem_sau", loi: `Bước ${j + 1} (${m.tenNgan}) phải đặt TRƯỚC bước ${k + 1} (${ds[k]!.tenNgan}) — người thật xem rồi mới thích/bình luận` });
    }
  });
  return out;
}
export function loiToHop(ds: MucToHop[]): string[] {
  return toHopChiTiet(ds).map((x) => x.loi);
}
// (07/10/2026) Dùng thao tác nhiều lần: "xem sau khi đã thích / bình luận" chỉ vô lý khi là CÙNG MỘT video / cùng danh sách. Xem một video KHÁC (địa chỉ khác, hoặc tìm lại danh sách mới ở giữa) thì bình thường
// (xem A → thích A → nghỉ → xem B → thích B). Cùng địa chỉ người dùng đưa → vẫn vô lý; cả hai để trống (làm trên danh sách / tự tìm) → vô lý nếu giữa hai bước không có bước nào tạo danh sách MỚI
// (kể cả chính bước j: bước tự tìm lần đầy đủ tự tìm lại).
function cungDoiTuong(ds: Partial<Pick<MucThuTu, "taoDs" | "dich">>[], k: number, j: number): boolean {
  const a = (ds[k]!.dich ?? "").trim(), b = (ds[j]!.dich ?? "").trim();
  if (a || b) return a === b;
  for (let i = k + 1; i <= j; i++) if (ds[i]!.taoDs?.length) return false;
  return true;
}

/** Hai bước nghỉ liền nhau là vô lý. */
function nghiLienChiTiet(ds: Pick<MucThuTu, "nghi">[]): MucThuTuChiTiet[] {
  const out: MucThuTuChiTiet[] = [];
  ds.forEach((t, j) => { if (t.nghi && ds[j + 1]?.nghi) out.push({ buoc: j + 1, ma: "nghi_lien", loi: `Bước ${j + 1} và bước ${j + 2} đều là nghỉ — gộp thành MỘT bước nghỉ (khoảng thời gian dài hơn)` }); });
  return out;
}
export function loiNghiLien(ds: Pick<MucThuTu, "nghi">[]): string[] {
  return nghiLienChiTiet(ds).map((x) => x.loi);
}

// ---------------- BIẾN THỂ TỰ TÌM (để trống địa chỉ một bài/video) — dùng CHUNG máy chủ (tu-dung.ts khoiHieuLucKeHoach) và trang web ----------------
// (rà soát 05/10/2026) Trang kiểm thứ tự theo cấu trúc bản CHÍNH của khối trong khi máy chủ lắp biến thể tự tìm (bước + danh sách riêng) → trang cho đặt
// cặp máy chủ từ chối và ngược lại. Chọn biến thể + từ khoá nằm ở ĐÂY (thuần, không YAML) để hai bên gọi đúng một hàm.
/** Cách lắp biến thể: "day_du" = phần tìm + phần làm; "chi_lam" = bước trước cùng khoá `chung` đã tìm; "chua_tu_khoa" = kịch bản không có từ khoá nào. */
export type CachTuTim = "day_du" | "chi_lam" | "chua_tu_khoa";
/** Id bước duy nhất của bản "chưa có từ khoá" (theo tên khối — tên khối là duy nhất trong một mạng). */
export const idChuaTuKhoa = (tenKhoi: string): string => `chua_tu_khoa_${tenKhoi}`;
/** Bước dùng biến thể tự tìm khi tham số địa chỉ (đã điền mặc định) RỖNG. */
export function dungBienTheTuTim(tuTim: { thamSo: string } | undefined, ts: Record<string, string | undefined>): boolean {
  return !!tuTim && !String(ts[tuTim.thamSo] ?? "").trim();
}
/** Từ khoá để biến thể tự tìm: tham số tu_khoa của bước khác trong kịch bản (gần nhất phía trước, rồi phía sau) → tên sản phẩm → mục tiêu. "" = không có. */
export function tuKhoaTuTim(khoi: readonly { thamSo?: Record<string, string> }[], viTri: number, hoSoTen?: string | null, mucTieu?: string | null): { tuKhoa: string; nguon: "buoc_tim" | "san_pham" | "muc_tieu" | "" } {
  const lay = (j: number): string => String(khoi[j]?.thamSo?.tu_khoa ?? "").trim();
  for (let j = viTri - 1; j >= 0; j--) if (lay(j)) return { tuKhoa: lay(j), nguon: "buoc_tim" };
  for (let j = viTri + 1; j < khoi.length; j++) if (lay(j)) return { tuKhoa: lay(j), nguon: "buoc_tim" };
  if (hoSoTen?.trim()) return { tuKhoa: hoSoTen.trim(), nguon: "san_pham" };
  if (mucTieu?.trim()) return { tuKhoa: mucTieu.trim(), nguon: "muc_tieu" };
  return { tuKhoa: "", nguon: "" };
}
/** Cách lắp của MỌI bước một kế hoạch (null = bản chính). Bước dùng biến thể có khoá `chung` đã gặp ở bước trước → chỉ phần làm.
 *  (07/10/2026, dùng thao tác nhiều lần) NGOẠI LỆ: bước dùng LẠI một thao tác đã có trước đó mà SAU lần tìm gần nhất của khoá `chung` đã có một bước tìm theo từ khoá MỚI (ô từ khoá `tu_khoa` có chữ)
 *  → tìm lại đầy đủ theo từ khoá mới ("Tìm bài A → bình luận → nghỉ → Tìm bài B → bình luận" — bình luận lần 2 phải theo B, không dùng lại danh sách của A). Kế hoạch cũ (mỗi thao tác một lần) không đổi. */
export function cachTuTimKeHoach(ds: readonly { tuTim?: { thamSo: string; chung: string }; ts: Record<string, string | undefined>; coTuKhoa: boolean; ma?: string }[]): (CachTuTim | null)[] {
  const daTim = new Set<string>();
  const timMoi = new Set<string>(); // khoá chung đã tìm mà sau đó có bước tìm theo từ khoá khác chen vào
  const daThay = new Set<string>(); // mã thao tác đã đứng trước
  return ds.map(({ tuTim, ts, coTuKhoa, ma }) => {
    if (String(ts.tu_khoa ?? "").trim()) for (const c of daTim) timMoi.add(c);
    const lap = !!ma && daThay.has(ma);
    if (ma) daThay.add(ma);
    if (!dungBienTheTuTim(tuTim, ts)) return null;
    if (!coTuKhoa) return "chua_tu_khoa";
    const da = daTim.has(tuTim!.chung) && !(lap && timMoi.has(tuTim!.chung));
    daTim.add(tuTim!.chung);
    if (!da) timMoi.delete(tuTim!.chung);
    return da ? "chi_lam" : "day_du";
  });
}
/** Cấu trúc (công khai, không YAML) của biến thể tự tìm theo từng cách lắp — bản đồ công khai gửi kèm để trang kiểm thứ tự đúng như máy chủ. */
export interface ThuTuTuTim { thamSo: string; chung: string; dayDu: ThuTuThaoTac; chiLam: ThuTuThaoTac; chuaTuKhoa: ThuTuThaoTac }
/** Dựng ThuTuTuTim từ khối có biến thể (cùng cách ghép YAML với tu-dung.ts khoiHieuLuc). */
export function thuTuTuTimCua(k: { ten: string; tuTim?: { thamSo: string; chung: string; yamlTim: string; yamlSteps: string; learned: Record<string, unknown> } }): ThuTuTuTim | undefined {
  const t = k.tuTim;
  if (!t) return undefined;
  const cua = (yamlSteps: string): ThuTuThaoTac => thuTuCua({ khoi: { yamlSteps, learned: t.learned } as ThaoTac["khoi"] });
  return { thamSo: t.thamSo, chung: t.chung, dayDu: cua(`${t.yamlTim.replace(/\s+$/, "")}\n\n${t.yamlSteps}`), chiLam: cua(t.yamlSteps), chuaTuKhoa: { ids: [idChuaTuKhoa(k.ten)], taoDs: [], canDs: [], nghi: false } };
}
/** Các bước của sơ đồ → MucThuTu theo khối HIỆU LỰC (biến thể tự tìm khi để trống địa chỉ) — đúng như máy chủ (so-do.ts thaoTacHieuLuc). Tham số
 *  thiếu lấy mặc định của bản đồ (như chuanHoaSoDo). Thao tác lạ → bỏ qua (trả mảng ngắn hơn: trang không kiểm, máy chủ vẫn kiểm). */
export function mucThuTuHieuLuc(nut: readonly { thaoTac: string; thamSo: Record<string, string> }[], thaoTac: readonly { ma: string; tenNgan: string; thuTu: ThuTuThaoTac; thuTuTuTim?: ThuTuTuTim; thamSo: readonly { ten: string; macDinh?: string }[] }[], hoSoTen?: string | null, mucTieu?: string | null): MucThuTu[] {
  const tt = nut.map((n) => thaoTac.find((t) => t.ma === n.thaoTac));
  if (tt.some((t) => !t)) return [];
  const ts = nut.map((n, j) => Object.fromEntries(tt[j]!.thamSo.map((d) => [d.ten, n.thamSo[d.ten] ?? d.macDinh ?? ""])));
  const cach = cachTuTimKeHoach(tt.map((t, j) => ({ tuTim: t!.thuTuTuTim, ts: ts[j]!, coTuKhoa: !!tuKhoaTuTim(nut, j, hoSoTen, mucTieu).tuKhoa, ma: t!.ma })));
  return tt.map((t, j) => {
    const c = cach[j], v = t!.thuTuTuTim;
    const thu = c && v ? (c === "day_du" ? v.dayDu : c === "chi_lam" ? v.chiLam : v.chuaTuKhoa) : t!.thuTu;
    return { ma: t!.ma, tenNgan: t!.tenNgan, ...thu, dich: diaChiDich(ts[j]) };
  });
}
/** Địa chỉ MỘT bài/video người dùng đưa cho bước (bai_url / video_url, cắt khoảng trắng) — "" nếu không có. */
export const diaChiDich = (thamSo: Record<string, string | undefined> | undefined): string => String(thamSo?.bai_url ?? thamSo?.video_url ?? "").trim();

/** Mọi lỗi THỨ TỰ của một dãy bước (theo đúng thứ tự máy chủ báo). Rỗng = thứ tự hợp lệ (máy chủ còn kiểm tham số). */
export function loiThuTu(ds: MucThuTu[], tatCa: Pick<MucThuTu, "tenNgan" | "taoDs">[]): string[] {
  if (!ds.length) return [];
  return [...loiTrungBuoc(ds), ...loiCanDanhSach(ds, tatCa), ...loiToHop(ds), ...loiNghiLien(ds)];
}

/** PHÂN LOẠI vàng / đỏ mọi vi phạm THỨ TỰ (chế độ mềm — dùng chung trang + máy chủ; câu báo = câu của loiToHop / loiNghiLien / loiCanDanhSach).
 *  VÀNG: nghỉ đứng cuối, chỉ có nghỉ, xem đặt sau khi đã thích/bình luận, hai nghỉ liền nhau, cần danh sách mà danh sách tạo ở XA hơn bước tạo danh sách gần nhất.
 *  ĐỎ: cần danh sách mà KHÔNG bước nào phía trước tạo danh sách đó.
 *  KHÔNG gồm loiTrungBuoc (trùng id bước = lỗi thư viện, luôn CỨNG) và các luật theo giá trị tham số (máy chủ tự thêm: ô bắt buộc trống, L-73, L-46).
 *  Kết quả sắp theo số bước tăng dần (ổn định). Dãy rỗng → []. Không sửa danh sách đầu vào. */
export function phanLoaiThuTu(ds: MucThuTu[], tatCa: Pick<MucThuTu, "tenNgan" | "taoDs">[]): PhanLoaiBuoc[] {
  if (!ds.length) return [];
  const ra: PhanLoaiBuoc[] = [
    ...toHopChiTiet(ds).map((x): PhanLoaiBuoc => ({ ...x, muc: "vang" })),
    ...nghiLienChiTiet(ds).map((x): PhanLoaiBuoc => ({ ...x, muc: "vang" })),
    ...canDanhSachChiTiet(ds, tatCa),
  ].map((x) => ({ buoc: x.buoc, muc: x.muc, ma: x.ma, loi: x.loi }));
  return ra.sort((a, b) => a.buoc - b.buoc);
}
